import { render, staticRenderFns } from "./CmgRewardCard.vue?vue&type=template&id=9887de0a&scoped=true&lang=pug"
import script from "./cmg-reward-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardCard.vue?vue&type=style&index=0&id=9887de0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9887de0a",
  null
  
)

export default component.exports